// image-modal.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/interfaces/interface-bakend/seguridad/users/user.interface';
import { OfertasLaboralesModule } from 'src/app/modulos/ofertas-laborales.module';

@Component({
    selector: 'app-image-modal',
    templateUrl: './image-modal.component.html',
    styleUrls: ['./image-modal.component.scss']
  })
export class ImageModalComponent {
  imgs: string[];
  usuario: User;
  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { images: string[], usuario: User }
  ) {
    this.imgs = data.images;
    this.usuario = data.usuario;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
